export default __webpack_public_path__ + "static/media/psych2.5d042120.svg";